<template>
  <div class="register">
    <v-stepper class="stepper" v-model="e1">
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Vereinsdaten</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2">Vereinslogo</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="3">Attribute</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="green" step="4">Links</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="5">Login</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>Vereinsdaten</h1>
          <br />
          <h2>
            Hier sind die Vereinsdaten wichtig. Diese Infos benötigen Spieler, Trainer
            und Scouts um deinen Verein finden zu können.
          </h2>
          <br />
          <label>Ansässig in Land</label>
          <v-autocomplete
            color="green"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            v-model="settings.nationality"
            solo
            attach
          ></v-autocomplete>
          <label>Region/Verband</label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="user_data.verband"
            solo
          ></v-select>
          <label v-if="user_data.verband">Liga</label>
          <v-select
            v-if="user_data.verband"
            color="green"
            :items="$store.state.filter_leagues[user_data.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="user_data.category"
            solo
          ></v-select>
          <label>Vereinsvorsitzende/r</label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="user_data.ceo"
            solo
          />
          <label>Cheftrainer/-in</label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="user_data.cheftrainer"
            solo
          />
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="2">
          <h1>Vereinslogo</h1>
          <br />
          <h2>
            Das Logo dient einer vernünftigen Außendarstellung. Das kannst du aber auch
            später erledigen.
          </h2>
          <br />
          <input
            class="fileInput"
            type="file"
            accept="image/*"
            @change="onFileSelected"
          />
          <br />
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn @click="next" color="green white--text" text>Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="3">
          <h1>Attribute</h1>
          <br />
          <h2>
            Hier kannst du eine Matching-Vorauswahl für Spieler und Trainer treffen.
            Diese ist später natürlich anpassbar.
          </h2>
          <br />
          <label>Aktueller Bedarf</label>
          <v-select
            color="green"
            :items="need"
            v-model="settings.will_be_found_by"
            solo
          ></v-select>
          <div
            class="range-slide"
            v-if="
              settings.will_be_found_by === 'Spieler' ||
              settings.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <h1>Spielerattribute</h1>

            <label
              >Alter (von {{ settings.playerAgeRange[0] }} bis
              {{ settings.playerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="settings.playerAgeRange"
              :min="14"
              :max="40"
            ></v-range-slider>
            <label>Geschlecht</label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="settings.playerprofile_sex"
              multiple
              solo
            ></v-select>

            <label>Position</label>
            <v-select
              color="green"
              :items="$store.state.positions"
              v-model="settings.playerprofile_position"
              solo
              multiple
            ></v-select>
          </div>
          <div
            v-if="
              settings.will_be_found_by === 'Trainer' ||
              settings.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <h1>Trainerattribute</h1>
            <label
              >Alter (von {{ settings.trainerAgeRange[0] }} bis
              {{ settings.trainerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="settings.trainerAgeRange"
              :min="14"
              :max="80"
            ></v-range-slider>
            <label>Geschlecht</label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="settings.trainerprofile_sex"
              solo
              multiple
            ></v-select>

            <label>Trainertyp</label>
            <v-select
              color="green"
              multiple
              :items="$store.state.trainer_types"
              v-model="settings.trainerprofile_type"
              solo
            ></v-select>
          </div>
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>
        <v-stepper-content class="content" step="4">
          <h1>Links</h1>
          <br />
          <h2>
            Sollte es bereits ein Transfermarkt- und/oder FuPa-Profil geben oder eine
            Vereinswebsite, dann kannst du sie im C4T-Profil anzeigen lassen.
          </h2>
          <br />
          <label for>Link Transfermarkt-Profil (optional)</label>
          <v-text-field
            color="green"
            v-model="settings.transfermarkt"
            hint="Kopiere den Link vom Transfermarkt-Profil."
            solo
          ></v-text-field>
          <label>Link FuPa-Profil (optional)</label>
          <v-text-field
            color="green"
            v-model="settings.fupa"
            hint="Kopiere den Link vom FuPa-Profil."
            solo
          ></v-text-field>
          <label>Link Website (optional)</label>
          <v-text-field
            color="green"
            v-model="settings.website"
            hint="Kopiere die URL der Website."
            solo
          ></v-text-field>
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" :loading="loading" @click="saveSettings"
            >Fertig</v-btn
          >
        </v-stepper-content>
        <v-stepper-content class="content" step="5">
          <h1>Login</h1>
          <br />
          <h2>
            Wir haben jetzt alle relevanten Informationen erhalten und dein
            Vereinsprofil erstellt.
          </h2>
          <br />
          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="loginUser">Login</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import firebase from 'firebase';
import axios from 'axios';
import { db } from '@/db';
import Button from '@/components/Button';
import Input from '@/components/Input';

export default {
  components: {
    Button,
    Input,
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },
  data: () => ({
    loading: false,
    menu: false,
    e1: 1,
    date: new Date().toISOString().substr(0, 10),
    settings: {
      name: '',
      date: '2018-03-02',
      profile_pic: '',
      playerAgeRange: [14, 22],
      trainerAgeRange: [30, 52],
      history: [],
      already_matched: [],
      player_country: 'Deutschland',
      trainer_country: 'Deutschland',
      userType: 'teams',
      galleryImages: ['', '', '', ''],
      newslinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
      videolinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
    },
    email: '',
    password: '',
    picture: '',
    uploading: false,
    select: { state: 'Florida', abbr: 'FL' },
    landkreis: ['Ohrekreis', 'Salzlandkreis', ''],
    need: ['Spieler', 'Trainer', 'Spieler & Trainer', 'Kein Bedarf'],
    showPW: false,
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),
  computed: {
    user_data() {
      return this.$store.state.user_data;
    },
  },
  methods: {
    next() {
      this.e1++;
      window.scrollTo(0, 0);
    },
    back() {
      this.e1--;
      window.scrollTo(0, 0);
    },
    loginUser() {
      this.$store.state.user_uid = firebase.auth().currentUser.id;
      this.$store.state.user_data.intro = false;
      this.$router.push({ name: 'team_home' });
    },
    saveDate(date) {
      this.settings, (date = this.date);
    },
    saveSettings() {
      if (this.settings.website) {
        this.settings.website = this.settings.website.replace('https://', '');
      }
      if (this.settings.fupa) {
        this.settings.fupa = this.settings.fupa.replace('https://', '');
      }
      if (this.settings.transfermarkt) {
        this.settings.transfermarkt = this.settings.transfermarkt.replace(
          'https://',
          '',
        );
      }
      this.loading = true;
      if (this.settings.profile_pic === '') {
        this.settings.profile_pic =
          'https://firebasestorage.googleapis.com/v0/b/chance4talents-d54b5.appspot.com/o/avatar.png?alt=media&token=e9e0f3a7-e480-4719-a02c-ba976d4225c3';
        this.settings.big_thumbnail =
          'https://firebasestorage.googleapis.com/v0/b/chance4talents-d54b5.appspot.com/o/avatar.png?alt=media&token=e9e0f3a7-e480-4719-a02c-ba976d4225c3';
      }
      this.$store.state.user_data = {
        ...this.$store.state.user_data,
        ...this.settings,
      };
      db.collection('teams')
        .doc(firebase.auth().currentUser.uid)
        .update({
          ...this.$store.state.user_data,
          ...this.settings,
          intro: false,
        })
        .then(() => {
          this.e1++;
          window.scrollTo(0, 0);
          this.loading = false;
        })
        .then((e) => {
          this.loading = false;
        });
    },
    onFileSelected(event) {
      this.picture = event.target.files[0];
      this.resizeImage(this.picture);
    },
    resizeImage() {
      this.$store.state.loading = true;

      const file = this.picture;

      // Create an image
      const img = document.createElement('img');
      // Create a file reader
      const reader = new FileReader();
      // Set the image once loaded into file reader
      reader.onload = function (e) {
        img.src = e.target.result;

        const canvas = document.createElement('canvas');
        // var canvas = $("<canvas>", {"id":"testing"})[0];
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        const MAX_WIDTH = 400;
        const MAX_HEIGHT = 300;
        let { width } = img;
        let { height } = img;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        const dataurl = canvas.toDataURL('image/png');
        this.picture = dataurl;
      };
      // Load files into file reader
      reader.readAsDataURL(file);

      this.uploadIMG();
    },
    uploadIMG() {
      const storageRef = firebase
        .storage()
        .ref(`images/${this.$store.state.user_data.id}/` + 'profilepic.png');
      storageRef
        .put(this.picture)
        .then((e) => {
          this.sucess_upload = e;
          return e.ref.getDownloadURL();
        })
        .then((downloadURL) => {
          this.settings.thumbnail = downloadURL;
          this.settings.big_thumbnail = downloadURL;
          this.settings.profile_pic = downloadURL;
          this.saveSettings();
        })
        .then(() => {
          if (this.success_upload.state === 'success') {
            if (window.location) {
              window.location.reload();
            } else location.reload();
          } else {
            this.$store.state.snackText =
              'Ups etwas ist schief gelaufen versuche es nochmal.';
            this.$store.state.snackbar = true;
          }
        })
        .catch((e) => {
          this.$store.state.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.fileInput {
  margin-bottom: 15px;
}

.register {
  padding: 0;
  padding-bottom: 200px;
  margin: 0;
  text-align: left;
}
.v-btn {
  margin-left: 0;
}
h2 {
  color: grey;
  font-weight: 400;
  font-size: 16px;
}
.stepper {
  width: 100%;
  min-height: 100vh;
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 89vh;
}

.range-slide {
  width: 100%;
}

.datepicker {
  margin-bottom: 20px;
}
</style>
